// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nav-item-dropdown .nav-dropdown>div{padding:10px}", "",{"version":3,"sources":["webpack://./client/components/nav-item-dropdown/nav-item-dropdown.scss"],"names":[],"mappings":"AAEE,qCACE,YAAA","sourcesContent":["@import \"~@/styles/index.scss\";\n.nav-item-dropdown {\n  .nav-dropdown > div {\n    padding: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
